import { PersonStore } from "../../../store/modules/person";
import { ConfigStore } from "../../../store/modules/config";
import { ContractsStore } from "../../../store/modules/contracts";
import { DiTokens } from "../../../services/diTokens";
import { getModule } from "vuex-module-decorators";
import { OperationVue } from "../OperationVue";
import IOperationService from "../../../services/operations/IOperationService";
import { container } from "@/inversify.config";
import { BarcodeOperationModel } from "../../../models/operations/BarcodeOperationModel";
import BarcodeOperationService from "../../../services/operations/BarcodeOperationService";


export default class C2BVue extends OperationVue {
  async init(): Promise<void> {
    this.loading = true;
    console.log(location.href)
    const url = location.href;
    this.service = container.get<IOperationService>(
      DiTokens.BarcodeOperationService
    );
    const qrString = `https://qr.nspk.ru/${this.$route.params.qrId.toString()}`
    let operationModel: BarcodeOperationModel = (await this.service.init( 
      qrString
    )) as BarcodeOperationModel;
    operationModel = await (this.service as BarcodeOperationService).execute(operationModel) as BarcodeOperationModel
    this.$router.push(operationModel.urlString)
    this.loading = false;
  }
}
